import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function ArticlesSection() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                精选<span className="text-primary-600">文章</span>
              </h2>
              <p className="mt-2 text-sm text-foreground-600">最新资讯与深度内容</p>
            </div>
            <Link
              to="/category/shipin-fuwu"
              className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {featuredArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
                    {article.tags.slice(0, 2).map((tag) => (
                      <span
                        key={tag}
                        className="px-2.5 py-1 rounded-full bg-white/85 backdrop-blur-sm text-xs font-medium text-foreground-700"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                    <span>{article.publishedAt}</span>
                    <span>·</span>
                    <span>{article.readTime}阅读</span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {article.summary}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}